module.exports = __webpack_public_path__ + "static/FIEC-logo.cb9e7d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FIEC-logo.png
// module id = 571
// module chunks = 35783957827783